import { render, staticRenderFns } from "./pedidosDocs.vue?vue&type=template&id=089d5840&"
import script from "./pedidosDocs.vue?vue&type=script&lang=js&"
export * from "./pedidosDocs.vue?vue&type=script&lang=js&"
import style0 from "./pedidosDocs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports